export default {
    // Define your getters here
    photos(state) {
        return state.photos;
    },
}